module.exports = __webpack_public_path__ + "master_calendar crop.png?54c81384ff6fa00020077cc6bd5ca296";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newborn/master_calendar crop.png
// module id = 30
// module chunks = 0